import { useParams, useHistory, useLocation } from 'react-router-dom';
import { Box } from '@evaneos/b2b-ui';
import { Alert as AlertLegacy, Button as ButtonLegacy } from '@evaneos/b2b-ui/legacy';
import { useIntl } from 'react-intl';

import { DossierId } from '../../../resources/dossier/types';
import { DeferAgreement } from '../components/alerts/DeferAgreement';
import { Vouchers } from '../components/alerts/Vouchers';
import { DEFERRED_TRIP_STEP, TRAVELLING_STEP } from '../../../domain/step';
import { SALES_PROCESS } from '../../../domain/process';
import { useGetDossierData } from '../../../resources/dossier/queries';
import { AlertInTripReview } from '../components/alerts/AlertInTripReview';
import { AlertPreTripReview } from '../components/alerts/AlertPreTripReview';
import { Reschedule } from '../components/alerts/Reschedule';
import { useSidePanel } from '../SidePanel/SidePanelContext';

/**
 * These insert boxes are displayed according to specific conditions (dossier step mainly).
 * They are not revamped yet (legacy)
 */
export const DossierAlertsDisplay = () => {
    const { formatMessage } = useIntl();
    const { dossierId } = useParams<{ dossierId: DossierId }>();
    const history = useHistory();
    const location = useLocation();
    const { openPanel } = useSidePanel();
    const { dossier, preTripReview, inTripReview, customerCareCrisisTicket } =
        useGetDossierData(dossierId) || {};

    const handleRescheduleClick = () => {
        // Add contractMode=editing to URL params to open Contract
        // in side panel in edit step
        const urlParams = new URLSearchParams(location.search);
        urlParams.set('contractMode', 'editing');
        history.push({
            pathname: location.pathname,
            search: urlParams.toString(),
        });

        openPanel({ contentType: 'contract' });
    };

    return (
        <Box>
            {preTripReview && dossier?.process === SALES_PROCESS && (
                <AlertPreTripReview preTripReview={preTripReview} dossierId={dossierId} />
            )}
            {inTripReview && dossier?.step !== TRAVELLING_STEP && (
                <AlertInTripReview inTripReview={inTripReview} dossierId={dossierId} />
            )}
            {dossier?.step === DEFERRED_TRIP_STEP && (
                <Reschedule dossierId={dossierId} onRescheduleButtonClick={handleRescheduleClick} />
            )}
            {customerCareCrisisTicket?.url && (
                <AlertLegacy collapsible={false} closable={false} type="error">
                    <p>{formatMessage({ id: 'dossier.crisis.description' })}</p>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={customerCareCrisisTicket?.url}
                    >
                        <ButtonLegacy danger>
                            {formatMessage({ id: 'dossier.crisis.link' })}
                        </ButtonLegacy>
                    </a>
                </AlertLegacy>
            )}
            {dossier?.step === DEFERRED_TRIP_STEP && <DeferAgreement dossierId={dossierId} />}
            <Vouchers dossierId={dossierId} />
        </Box>
    );
};
